var BaseObserver = /** @class */ (function () {
    function BaseObserver(callback) {
        this.isStarted = false;
        this.callback = callback;
    }
    BaseObserver.prototype.start = function () {
        if (this.isStarted) {
            throw Error("Already started");
        }
        this.isStarted = true;
    };
    BaseObserver.prototype.stop = function () {
        this.isStarted = false;
    };
    return BaseObserver;
}());
export default BaseObserver;
//# sourceMappingURL=BaseObserver.js.map